import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { Add } from "@mui/icons-material";
import { DirectorResponseAddCommand } from "../../../../../services/varianceService/commands/DirectorResponseAddCommand";
import { useDirectorResponseAddMutation } from "../../../../../services/varianceService/variance-api";
import { toggleDirectorResponseAddModal } from "../../../../../app/slices/VarianceModuleSlice";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";

function DirectorResponseAddDialog() {
    const dispatch = useAppDispatch();
    const { data } = useMyProfileQuery();
    const modalOpen = useAppSelector((state) => state.varianceModule.DirectorResponseAddModal);
    const varianceId = useAppSelector((state) => state.varianceRequest.varianceRequest.id);
    const [text, setText] = React.useState("");
    const [save] = useDirectorResponseAddMutation();

    const saveResponse = () => {
        let command = new DirectorResponseAddCommand(varianceId!, text, data!.identity!);
        save(command);
    };

    return (
        <React.Fragment>
            <Button startIcon={<Add />} variant="outlined" onClick={() => dispatch(toggleDirectorResponseAddModal())}>
                Add Response
            </Button>
            <Dialog open={modalOpen} onClose={() => setText("")}>
                <DialogTitle>Add Director Response</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Response"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        multiline
                        fullWidth
                        sx={{ width: "500px", marginTop: "10px" }}
                        minRows={5}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { dispatch(toggleDirectorResponseAddModal()); setText(""); }}>Cancel</Button>
                    <Button onClick={() => { saveResponse(); dispatch(toggleDirectorResponseAddModal()); setText(""); }}>Save</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export { DirectorResponseAddDialog };
